import { ReactNode } from 'react'
import { Link } from 'react-router'

import { ThemeSwitcher } from '@/components/ThemeSwitcher'
import { LOGO_URL } from '@/lib/brand'
import { cn } from '@/lib/utils'

export interface AuthLayoutProps {
  children: ReactNode
  /** Skryje značku nahoře (např. když ji stránka nechce) */
  hideWordmark?: boolean
}

export interface AuthFooterProps {
  children?: ReactNode
}

/** Značka invo.space: logo a název, bez ilustrací. */
export const Wordmark = ({ className }: { className?: string }) => (
  <Link to="/" className={cn('inline-flex items-center gap-2.5 rounded-md', className)} aria-label="invo.space">
    <img src={LOGO_URL} alt="" className="size-7" />
    <span className="text-[15px] font-medium tracking-[-0.01em] lowercase">invo.space</span>
  </Link>
)

/** Klidná karta uprostřed obrazovky (přihlášení, registrace, hesla). */
export const AuthCard = ({
  title,
  description,
  children,
  className,
}: {
  title?: ReactNode
  description?: ReactNode
  children: ReactNode
  className?: string
}) => (
  <div className={cn('w-full rounded-lg border bg-background p-6 sm:p-8', className)}>
    {(title || description) && (
      <div className="mb-6 space-y-1.5">
        {title && <h1 className="text-xl font-medium tracking-[-0.02em]">{title}</h1>}
        {description && <p className="text-sm text-muted-foreground text-pretty">{description}</p>}
      </div>
    )}
    {children}
  </div>
)

export const AuthFooter = ({ children }: AuthFooterProps) => (
  <div className="flex flex-col items-center gap-3 text-sm text-muted-foreground">
    {children}
    <ThemeSwitcher />
  </div>
)

export const AuthLayout = ({ children, hideWordmark = false }: AuthLayoutProps) => (
  <div className="flex min-h-svh flex-col items-center bg-muted/40 px-4 py-10 sm:py-16">
    <div className="flex w-full max-w-[400px] flex-1 flex-col items-center gap-6 sm:justify-center sm:pb-[8vh]">
      {!hideWordmark && <Wordmark className="mb-2" />}
      {children}
    </div>
  </div>
)

AuthLayout.displayName = 'AuthLayout'
